import { createResource } from 'react-resource-router';
import { assert, AssertionError } from '@atlassian/eoc-common';
import { getRoutingRules } from '../endpoints';
export const routingRulesResource = createResource({
  type: 'routingRulesResource',
  getKey: () => 'routingRulesResource',
  getData: async routerContext => {
    var _routerContext$match$;
    const teamId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.teamId;
    assert(!!teamId, new AssertionError('routingRulesResource', 'teamId should be set to fetch routing-rules'));
    return getRoutingRules(teamId);
  },
  isBrowserOnly: true
});